/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import NewTextStory from "./new";
import OldTextStory from "./old";
import { useSelector } from "react-redux";
import StoryRowWrapper from "../story-row-wrapper.js";

export const TextStory = props => {
  const { config, storyStoreField, storyPageType } = props;
  const isPbEnabled = get(config, ["pagebuilder-config", "featureToggle", "storyPage"], false);
  if (isPbEnabled) {
    const storyRows = useSelector(state =>
      get(state, ["qt", "config", "pagebuilder-config", storyStoreField, storyPageType, "rows"], [])
    );
    return (
      <StoryRowWrapper rows={storyRows}>
        <NewTextStory {...props} />
      </StoryRowWrapper>
    );
  }
  return <OldTextStory {...props} />;
};

TextStory.propTypes = {
  config: PropTypes.object,
  storyStoreField: PropTypes.string,
  storyPageType: PropTypes.string
};

TextStory.defaultProps = {
  storyStoreField: "story",
  storyPageType: "text-story"
};
export default TextStory;
